import { render, staticRenderFns } from "./newWhitelist.vue?vue&type=template&id=5acb794b&scoped=true"
import script from "./newWhitelist.vue?vue&type=script&lang=js"
export * from "./newWhitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb794b",
  null
  
)

export default component.exports